import { useMemo } from 'react';
import { SchedulerLiverSurgeons } from '@lp/features/Scheduler';
import { useAuthContext } from '@lp/core/auth';
import { SchedulerPermissions } from '@/permissions';
import { OrganType } from '@/api/apis/case';

export const SLiSchedule = () => {
  const { employeeData, checkPermission } = useAuthContext();
  const showSettings = checkPermission(SchedulerPermissions.SSchedulesSettingsWrite);

  const hasSScheduleWritePermission = useMemo(() => {
    const hasWritePermissions = checkPermission(SchedulerPermissions.SSchedulesWrite);
    const hasSLiWritePermissions = checkPermission(SchedulerPermissions.SLiSchedulesWrite);

    const canEditSLiSchedule =
      hasSLiWritePermissions && employeeData?.employee?.rsScheduleManagerOrgans.includes(OrganType.Liver);

    return hasWritePermissions || canEditSLiSchedule;
  }, [checkPermission, employeeData?.employee.rsScheduleManagerOrgans]);

  return <SchedulerLiverSurgeons readonly={!hasSScheduleWritePermission} showSettings={showSettings} />;
};
